import { render, staticRenderFns } from "./CompareBar.vue?vue&type=template&id=6048c205&scoped=true"
import script from "./CompareBar.vue?vue&type=script&lang=js"
export * from "./CompareBar.vue?vue&type=script&lang=js"
import style0 from "./CompareBar.vue?vue&type=style&index=0&id=6048c205&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_eb30a0289a409b0a489ae932e3a15a73/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6048c205",
  null
  
)

export default component.exports